/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {createSlice, PayloadAction} from '@reduxjs/toolkit'


interface ReloadSignalState {
    person: boolean,
    customer: boolean,
    device: boolean,
    devicemodel: boolean,
    user: boolean,
    exam: boolean,
    event: boolean,
    manualEntry: boolean,
    upload: boolean,
    mappings: boolean,
    columnMapping: boolean,
    todo: boolean,
}

const initialReloadSignalState: ReloadSignalState = {
    person: false,
    customer: false,
    device: false,
    devicemodel: false,
    user: false,
    exam: false,
    event: false,
    manualEntry: false,
    upload: false,
    mappings: false,
    columnMapping: false,
    todo: false,
}


const reloadSignalSlice = createSlice({
    name: 'reloadSignals',
    initialState: initialReloadSignalState,
    reducers: {
        triggerReload: (state: ReloadSignalState, key: PayloadAction<string>) => {
            switch (key.payload) {
                case 'person':
                    state.person = !state.person;
                    break
                case 'customer':
                    state.customer = !state.customer;
                    break
                case 'device':
                    state.device = !state.device;
                    break
                case 'devicemodel':
                    state.devicemodel = !state.devicemodel;
                    break
                case 'user':
                    state.user = !state.user;
                    break
                case 'exam':
                    state.exam = !state.exam;
                    break
                case 'event':
                    state.event = !state.event;
                    break
                case 'manualEntry':
                    state.manualEntry = !state.manualEntry;
                    break
                case 'upload':
                    state.manualEntry = !state.manualEntry;
                    break
                case 'mappings':
                    state.mappings = !state.mappings;
                    break
                case 'columnMapping':
                    state.columnMapping = !state.columnMapping;
                    break
                case 'todo':
                    state.todo = !state.todo;
                    break
                default:
                    console.debug("Unknown reload trigger: " + key.payload);
                    break
            }
        }
    }
})

export const {triggerReload} = reloadSignalSlice.actions
export const reloadSignalReducer = reloadSignalSlice.reducer
